module.exports = __webpack_public_path__ + "img/center front length to empire seam.27192435.png";